export function truncateString(str: string) {
  if (str.length > 6) {
    return str.substring(0, 6) + "..." + str.substring(str.length - 4)
  }
  return str
}

/**
 * Format the subscriber count to a nice string.
 */
export const formatSubscriberCount = (
  count: number,
  showUnder100?: boolean,
  concise?: boolean
): string | null => {
  // Under 100 with flag to show: Show <100
  if (count < 100 && showUnder100) return concise ? `<100` : `<100 subscribers`

  // Under 100: Hide subscriber info
  if (count < 100) return null

  // Between 100 and 1,000: Round down to nearest 100
  if (count <= 1000) {
    const rounded = Math.floor(count / 100) * 100
    return concise ? `${rounded}+` : `Over ${rounded} subscribers`
  }

  // Between 1,000 and 10,000: Round down to first two digits
  if (count <= 10000) {
    const rounded = Math.floor(count / 100) * 100
    return concise
      ? `${formatNumberWithUnit(rounded)}+`
      : `Over ${formatNumberWithUnit(rounded)} subscribers`
  }

  // Between 10,000 and 100,000: Round to nearest 1,000
  if (count <= 100000) {
    const rounded = Math.round(count / 1000) * 1000
    return concise
      ? `${formatNumberWithUnit(rounded)}+`
      : `Over ${formatNumberWithUnit(rounded)} subscribers`
  }

  // Over 100,000: Round down to first two digits
  const rounded = Math.floor(count / 10000) * 10000
  return concise
    ? `${formatNumberWithUnit(rounded)}+`
    : `Over ${formatNumberWithUnit(rounded)} subscribers`
}

/** Format number to short one decimal with unit */
export function formatNumberWithUnit(num: number): string {
  if (num >= 1_000_000)
    return `${(num / 1_000_000).toFixed(1)}m`.replace(".0", "")

  if (num >= 1_000) return `${(num / 1_000).toFixed(1)}k`.replace(".0", "")

  return num.toString()
}
